import { useSearchParams } from 'react-router-dom';

import { useGetExerciseOptions } from '../../../redux/api/exerciseConfigAPI';
import { useGetExerciseById } from '../../../redux/api/exercisesAPI';
import { orderTraining } from '../../../utils/training/set-utils';

export function useViewExercisePage(id?: string) {
  const [searchParams] = useSearchParams();
  const fromTrainingId = searchParams.get('fromTrainingId') ?? undefined;
  const fromProgramId = searchParams.get('fromProgramId') ?? undefined;

  const queryArg = {
    id: id ?? '',
    ...(fromTrainingId ? { fromTrainingId } : {}),
    ...(fromProgramId ? { fromProgramId } : {}),
  };

  const {
    data: response,
    error,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useGetExerciseById(queryArg, { skip: !id });
  const { data: exerciseOptions } = useGetExerciseOptions();

  return {
    exercise: response?.exercise,
    trainings:
      response && exerciseOptions && response.trainings
        ? response.trainings
        : [],
    error,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
}
